import { client } from "@/config/client"

interface RemoveFlashcardParams {
  flashcardId: string
}

export default function remove({ flashcardId }: RemoveFlashcardParams) {
  return client.del(`/v1/deck-sets/${flashcardId}`)
}
